import { rgba } from "polished"

const colors = {
  text: "#393A3B",
  alt: rgba("#393A3B", 0.5),
  background: "#fff",
  wash: "#f2f2f2",
  primary: "#FF4D01",
  secondary: "#132048",
  modes: {
    dark: {
      text: "#fff",
      alt: rgba("#fff", 0.5),
      background: "#393A3B",
      wash: "#393A3B",
      primary: "#FF4D01",
      secondary: "#132048",
    },
  },
}

export default colors
